import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const ErrorMessage = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.primary.red};
    margin: 1em 0;
  }
`;
